import React from 'react';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';

// Import icons for each score type
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import TrainIcon from '@mui/icons-material/Train';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';

// Example Walk Score JSON data
const walkScoreExampleData = {
  status: 1,
  walkscore: 55,
  description: "Somewhat Walkable - Some errands can be accomplished on foot.",
  updated: "2016-11-17 04:40:31.218250",
  more_info_icon: "https://cdn.walk.sc/images/api-more-info.gif",
  more_info_link: "https://www.walkscore.com/how-it-works/",
  ws_link:
    "https://www.walkscore.com/score/802-ayers-st-memphis-tn-38107",
  help_link: "https://www.walkscore.com/how-it-works/",
  snapped_lat: 47.6085,
  snapped_lon: -122.3295,
  transit: { score: 37, description: "Some Transit", summary: "A few nearby public transportation options." },
  bike: { score: 51, description: "Bikeable - Some bike infrastructure." }
};

const WalkScoreCard = ({ walkScoreData }) => {
  return (
    <Card
      sx={{
        width: 765,
        backgroundColor: 'white',
        marginBottom: '20px',
        padding: '20px',
        borderRadius: '20px'
      }}
    >
      {walkScoreData && walkScoreData.status === 1 ? (
        <Box>
          <p style={{ marginLeft: '15px', marginBottom: '10px', marginTop: '0px' }}>
            <span style={{ fontWeight: "600" }}>Transportation Scores</span>
          </p>
          {/* Row with Walk, Transit, and Bike scores */}
          <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
            {/* Walk Score with tooltip */}
            <Tooltip
              title={`Walk Score: ${walkScoreData.walkscore} - ${walkScoreData.description} (Updated: ${walkScoreData.updated})`}
              placement="top"
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'default' }}>
                <DirectionsWalkIcon fontSize="large" />
                <Typography variant="subtitle1" sx={{ fontWeight: '600', mt: 1 }}>
                  Walk
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: '700' }}>
                  {walkScoreData.walkscore}
                </Typography>
              </Box>
            </Tooltip>
            {/* Transit Score with tooltip */}
            <Tooltip
              title={`Transit Score: ${walkScoreData.transit.score} - ${walkScoreData.transit.description}: ${walkScoreData.transit.summary}`}
              placement="top"
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'default' }}>
                <TrainIcon fontSize="large" />
                <Typography variant="subtitle1" sx={{ fontWeight: '600', mt: 1 }}>
                  Transit
                </Typography>
                {walkScoreData.transit && (
                  <Typography variant="h5" sx={{ fontWeight: '700' }}>
                    {walkScoreData.transit.score}
                  </Typography>
                )}
              </Box>
            </Tooltip>
            {/* Bike Score with tooltip */}
            <Tooltip
              title={`Bike Score: ${walkScoreData.bike.score} - ${walkScoreData.bike.description}`}
              placement="top"
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'default' }}>
                <DirectionsBikeIcon fontSize="large" />
                <Typography variant="subtitle1" sx={{ fontWeight: '600', mt: 1 }}>
                  Bike
                </Typography>
                {walkScoreData.bike && (
                  <Typography variant="h5" sx={{ fontWeight: '700' }}>
                    {walkScoreData.bike.score}
                  </Typography>
                )}
              </Box>
            </Tooltip>
          </Box>
          {/* More Info Link */}
          {walkScoreData.ws_link && (
            <Box sx={{ mt: 2, textAlign: 'center' }}>
              <a href={walkScoreData.ws_link} target="_blank" rel="noopener noreferrer">
                More Info
              </a>
            </Box>
          )}
        </Box>
      ) : (
        <Typography variant="h6" sx={{ mt: '1rem', ml: '25px', textAlign: 'center', fontWeight: '600' }}>
          Walk Score
        </Typography>
      )}
    </Card>
  );
};

const App = () => {
  return (
    <div>
      <WalkScoreCard walkScoreData={walkScoreExampleData} />
    </div>
  );
};

export default App;
